import { RuleNumberArray } from "../../../src/types/rule";
import { ApiMapCard } from "@/src/types/apimap";
import GamePlaySingleCardView from "../play/singlecardview";
import React, { useMemo } from "react";
import styles from './fixedcards.module.css';
import { useGame } from "@/src/contexts/game";
import { NumericInput } from "@blueprintjs/core";

type Props = {
    index: number;
    isDisabled?: boolean;
    isEditable: boolean;
    mapCard: ApiMapCard;
    onChange: (any) => void;
    rule: RuleNumberArray;
    value: number[];
};

export default function GameRuleNumberFixedCard({
    index,
    isDisabled,
    isEditable,
    onChange,
    mapCard,
    rule,
    value,
}: Props) {
    const { g } = useGame();

    const bonus = useMemo(
        (): React.ReactNode => {
            if (isDisabled) {
                return null;
            }

            const cardBonus = g.getFixedCardTurninBonus(mapCard.id);

            if (!isEditable) {
                return cardBonus;
            }

            return <NumericInput
                allowNumericCharactersOnly={true}
                inputSize={3}
                onValueChange={
                    (newCardBonus) => {
                        const newValue = [...value];
                        newValue[index] = isNaN(newCardBonus) ? 0 : newCardBonus;
                        onChange(newValue);
                    }
                }
                value={cardBonus}
            />
        },
        [g, index, onChange, value, isDisabled, isEditable, mapCard.id],
    );

    if (isDisabled) {
        return null;
    }

    return (
        <tr key={mapCard.id}>
            <td className={styles.fixedCardContainer}>
                {
                    !mapCard.isWild && <GamePlaySingleCardView
                        mapCard={mapCard}
                        className={styles.card}
                        width={24}
                        height={32}
                    />
                }
            </td>
            <td align="left" className={styles.fixedCardName}>
                &nbsp;{mapCard.isWild ? 'All Different' : mapCard.name}
            </td>
            <td className={styles.fixedCardValue}>
                {bonus}
            </td>
        </tr>
    );
}
